import { CurrencyCircleDollarIcon } from "../../modules/Icons";
import { SavingsBadgeProps } from "../../types/components/shared/SavingsBadge";

const SavingsBadge: React.FC<SavingsBadgeProps> = (props) => {
const { text } = props;
  return (
    <span cy-test-id="savings-badge-span" className='flex items-center h-[36px] gap-[4px] bg-[#FFAC26] bg-opacity-[15%] rounded-[5px] p-[6px] whitespace-nowrap mt-8 md:mt-0'>
      <CurrencyCircleDollarIcon />
      <span className='text-[12px] md:text-[15px] font-semibold text-orange-800'>{text}</span>
    </span>
  )
}

export default SavingsBadge;